// src/components/CardCategoria.js
import "./CardCategoria.css";

export default function CardCategoria({
  nome,
  status,
  mensagem,
  temAposta,
  onClick
}) {
  const clicavel = status === "aberto";
  const classeBotao = temAposta ? "botao-acao azul" : "botao-acao preto";
  const textoBotao = temAposta ? "ATUALIZAR" : "APOSTAR";
  const classeEstados = status === "aberto" ? "estados aberto" : "estados fechado";

  const handleCardClick = () => {
    if (clicavel && typeof onClick === "function") {
      onClick();
    }
  };

  return (
    <div
      className={`card-categoria ${clicavel ? "card-clicavel" : ""}`}
      onClick={handleCardClick}
    >
      <div className="titulo-categoria3">{nome}</div>

      <button
        className={classeBotao}
        onClick={(e) => {
          e.stopPropagation();
          if (clicavel && typeof onClick === "function") {
            onClick();
          }
        }}
        disabled={!clicavel}
        style={{ pointerEvents: clicavel ? "auto" : "none" }}
      >
        {textoBotao}
      </button>

      {status === "fechado" ? (
        <div className="status-fechado">
          <div className="fechado-texto">Fechado</div>
          <div className="mensagem-fechado">{mensagem}</div>
        </div>
      ) : (
        <div className={classeEstados}>{mensagem}</div>
      )}
    </div>
  );
}
